var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kimg"},[_c('img',{staticClass:"img",attrs:{"src":_vm.src,"alt":""},on:{"click":_vm.Onclick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }